import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule } from '@angular/common/http';
import { HttpModule } from '@angular/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule, Routes } from '@angular/router';
import 'hammerjs';
import { SharedModule } from './core/modules/shared.module';
import { AppComponent } from './app.component';
import { FuseMainModule } from './main/main.module';
import { FuseSplashScreenService } from './core/services/splash-screen.service';
import { FuseConfigService } from './core/services/config.service';
import { FuseNavigationService } from './core/components/navigation/navigation.service';
import { FuseOrganisationsModule } from './main/content/organisations/organisations.module';
import { FuseModulesModule } from './main/content/modules/modules.module';
import { FuseLoginModule } from './main/content/login/login.module';
import { TranslateModule } from '@ngx-translate/core';
import { FuseUsersModule } from './main/content/users/users.module';
import { AuthService } from './data/services/auth.service';
import { AuthGuard } from './data/services/authGuard';
import { AuthDataManager } from './data/auth.datamanager';
import { UsersDataManager } from './data/users.datamanager';
import { UsersService } from './data/services/users.service';
import { ExportsService } from './data/services/exports.service';
import { OrganisationsService } from './data/services/organisations.service';
import { OrganisationsDataManager } from './data/organisations.datamanager';
import { AddOrganisationModule } from './main/content/organisations/add/add.organisation.dialog.module';
import { AddAdminModule } from './main/content/organisations/admin/add.admin.dialog.module';
import { AddUserModule } from './main/content/users/add/add.user.dialog.module';
import { PromoteUserModule } from './main/content/users/promote/promote.user.dialog.module';
import { ConfirmDialogModule } from './main/content/dialogs/confirm/confirm.dialog.module';
import { EditUserModule } from './main/content/users/edit/edit.user.dialog.module';
import { ModulesService } from './data/services/modules.service';
import { ModulesDataManager } from './data/modules.datamanager';
import { AddModuleDialogModule } from './main/content/modules/add/add.module.dialog.module';
import { UploadDataManager } from './data/upload.datamanager';
import { UploadService } from './data/services/upload.service';
import { AddOrganisationModuleDialogComponent } from './main/content/modules/addOrganisation/add.organisation.module.dialog.component';
import { AddOrganisationModuleDialogModule } from './main/content/modules/addOrganisation/add.organisation.module.dialog.module';
import { EditOrganistationModule } from './main/content/organisations/edit/edit.organisation.dialog.module';
import { FuseToolbarComponent } from './main/toolbar/toolbar.component';
import { AddUserDialogComponent } from './main/content/users/add/add.user.dialog.component';
import { ProfileModule } from './main/toolbar/profile/profile.dialog.module';
import { ProfileDialogComponent } from './main/toolbar/profile/profile.dialog.component';
import { EqualValidator } from './helper/equal.validator';
import { FuseProgressModule } from './main/content/progress/progress.module';
import { HashLocationStrategy, LocationStrategy } from '@angular/common';
import { ImportUsersModule } from './main/content/users/import/import.users.dialog.module';
import { ExportUsersModule } from './main/content/users/export/export.users.dialog.module';
import { AdvancedFilteringByFileUsersModule } from './main/content/users/advanced.filtering/advanced.filtering.by.file.users.dialog.module'; 
import { EditModuleDialogModule } from './main/content/modules/edit/edit.module.dialog.module';
import { ShowExamModule } from './main/content/progress/exam/show.exam.dialog.module';
import { ResetPasswordDialogModule } from './main/content/login/reset/reset-password.dialog.module';
import { TwoFactorModule } from './main/content/two-factor/two-factor.module';

import { LogEntriesModule } from './main/content/log.entries/log.entries.module';
import { LogEntryDetailDialogModule } from './main/content/log.entries/detail/detail.dialog.module';
import { LogEntriesService } from './data/services/log.entries.service';
import { LogEntriesDataManager } from './data/log.entries.datamanager';
import { SessionService } from './data/services/session.service';

const appRoutes: Routes = [
    {
        path: '**',
        redirectTo: ''
    }
];

@NgModule({
    declarations: [
        AppComponent,
        EqualValidator
    ],
    imports: [
        BrowserModule,
        HttpClientModule,
        HttpModule,
        BrowserAnimationsModule,
        RouterModule.forRoot(appRoutes),
        SharedModule,
        TranslateModule.forRoot(),
        FuseMainModule,
        FuseOrganisationsModule,
        FuseUsersModule,
        FuseLoginModule,
        FuseModulesModule,
        AddOrganisationModule,
        AddAdminModule,
        AddUserModule,
        EditUserModule,
        EditOrganistationModule,
        PromoteUserModule,
        ConfirmDialogModule,
        AddModuleDialogModule,
        ResetPasswordDialogModule,
        TwoFactorModule,
        AddOrganisationModuleDialogModule,
        EditModuleDialogModule,
        ShowExamModule,
        ImportUsersModule,
        ExportUsersModule,
        AdvancedFilteringByFileUsersModule,
        ProfileModule,
        FuseProgressModule,
        LogEntriesModule,
        LogEntryDetailDialogModule
    ],
    providers: [
        FuseSplashScreenService,
        FuseConfigService,
        FuseNavigationService,
        AuthService,
        UsersService,
        ExportsService,
        ModulesService,
        OrganisationsService,
        UploadService,
        AuthDataManager,
        UsersDataManager,
        ModulesDataManager,
        OrganisationsDataManager,
        UploadDataManager,
        LogEntriesDataManager,
        LogEntriesService,
        SessionService,
        AuthGuard,
        { provide: LocationStrategy, useClass: HashLocationStrategy }
    ],
    entryComponents: [

    ],

    bootstrap: [
        AppComponent
    ]
})
export class AppModule {
}



// WEBPACK FOOTER //
// /tmp/build_f0fbff5b/src/app/app.module.ts